
const PUBLIC_PROD_API_SERVER = 'https://web-api.findinai.cn';
const PUBLIC_PREV_API_SERVER = 'https://web-api.pre.findinai.cn';
const PUBLIC_STAGE_API_SERVER = 'https://findin-api.t.xiehuaai.com';

const pkg = process.env.NEXT_PUBLIC_PACKAGE;

// 客户端版本（使用 location.host）
export const getAPIHost = () => {
  if (typeof window === 'undefined') {
    return '/api/';
  }
  if (pkg === 'release') {
    const isPreviewEnv = window.location.host?.startsWith('preview') || false;
    if (isPreviewEnv) {
      return PUBLIC_PREV_API_SERVER;
    } else {
      return PUBLIC_PROD_API_SERVER;
    }
  } else {
    return PUBLIC_STAGE_API_SERVER;
  }
}

export const api = (url: string, direct?: boolean) => {
  url = url.replace(/^\//, '');
  if (direct) {
    return `${getAPIHost()}/${url}`;
  }
  return `/api/${url}`;
}

export const host = (url: string) => {
  return api(url, true);
}

